import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import useAuth from './useAuth';
import './Manage_User.css';
import * as XLSX from 'xlsx';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import Pagination from './Pagination.js';
//import { BASE_URL } from "./Constants.js";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Loader = () => (
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
        </div>
        <p>Loading...</p>
    </div>
);

const FinanceSettlementForm = () => {
    const [financeStatusFilter, setFinanceStatusFilter] = useState('');
    const [EmpCode, setEmpCode] = useState('');
    const [RptMgr, setRptMgr] = useState('');
    const [items, setItems] = useState([]);
    const [responseMessage, setResponseMessage] = useState('');
    const [filteredItems, setFilteredItems] = useState([]);
    const [is_audit_approval, setis_audit_approval] = useState(false);
    const [is_finance_approval, setis_finance_approval] = useState(false);
    const [showLogPopup, setShowLogPopup] = useState(false);
    const [logResponse, setLogResponse] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [sortColumn, setSortColumn] = useState('SysNo');
    const [sortOrder, setSortOrder] = useState('asc');
    const navigate = useNavigate();
    useAuth();

    useEffect(() => {
        // Retrieve the saved auditStatusFilter from localStorage if available
        const savedFilter = localStorage.getItem('financeStatusFilter');
        if (savedFilter) {
            setFinanceStatusFilter(savedFilter);
        }
    }, []);

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${API_BASE_URL}profile`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();

                if (result.status) {
                    setEmpCode(result.profile.emp_code || '');

                    setRptMgr(result.profile.report_mngr || '');
                    setis_audit_approval(result.profile.is_audit_approval === 'Y');
                    setis_finance_approval(result.profile.is_finance_approval === 'Y');
                    // fetchItems(result.profile.emp_code, result.profile.report_mngr);
                } else {
                    setResponseMessage('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            }
        };

        fetchProfileData();
    }, []);


    // Handle changing the audit status filter
    const handleFinanceStatusChange = (e) => {
        const newFilter = e.target.value;
        setFinanceStatusFilter(newFilter); // Set the selected audit status filter
        localStorage.setItem('financeStatusFilter', newFilter); // Save the filter in localStorage
    };
    useEffect(() => {
        const fetchItems = async (EmpCode) => {
            try {
                const token = localStorage.getItem('authToken');
                console.log("RptMgr", EmpCode);
                if (!token) return;

                const response = await fetch(`${API_BASE_URL}getsettlement?accounts_manager=${encodeURIComponent(EmpCode)}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                if (result.status) {
                    console.log("checkdata", result.settlement);
                    setItems(result.settlement);
                } else {
                    setError(result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setError('Failed to fetch items');
            } finally {
                setLoading(false);
            }
        };




        if (EmpCode) {
            fetchItems(EmpCode);
        }
    }, [EmpCode, navigate]);

    const handleLog = async (id) => {
        try {
            const token = localStorage.getItem('authToken');

            const response = await fetch(`${API_BASE_URL}settlement_log_form/${id}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            const result = await response.json();

            // Save API response
            setLogResponse(result);
            setShowLogPopup(true);

        } catch (error) {
            console.error("Error fetching log:", error);
            setLogResponse({ message: "Something went wrong!" });
            setShowLogPopup(true);
        }
    };

    useEffect(() => {
        const filtered = items.filter(item => {
            const financeStatusMatch = !financeStatusFilter || item.account_status === financeStatusFilter;
            return (
                item.comp_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.grade.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.purpose.toLowerCase().includes(searchQuery.toLowerCase()) ||
                // item.report_mngr.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.rpt_mgr_status.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.audit_status.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.account_status.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.days.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.trans_code.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.audit_approved_amount.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.emp_code.toLowerCase().includes(searchQuery.toLowerCase())
            ) && financeStatusMatch;
        });

        const sorted = filtered.sort((a, b) => {
            if (a[sortColumn] < b[sortColumn]) return sortOrder === 'asc' ? -1 : 1;
            if (a[sortColumn] > b[sortColumn]) return sortOrder === 'asc' ? 1 : -1;
            return 0;
        });

        setFilteredItems(sorted);
        setCurrentPage(1); // Reset to first page when items or search query changes
    }, [searchQuery, items, sortColumn, sortOrder, financeStatusFilter]);

    const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

    const startItem = indexOfFirstItem + 1;
    const endItem = Math.min(indexOfLastItem, filteredItems.length);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const parseRemarks = (remarks) => {
        try {
            const jsonStart = remarks.indexOf('{');
            if (jsonStart === -1) return null;
            return JSON.parse(remarks.substring(jsonStart));
        } catch (e) {
            return null;
        }
    };
    const claimedLog = logResponse?.data?.[0];
    const auditLog = logResponse?.data?.[1];

    const claimedParsed = claimedLog ? parseRemarks(claimedLog.remarks) : null;
    const auditParsed = auditLog ? parseRemarks(auditLog.remarks) : null;

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleSort = (column) => {
        let sortedItems;
        if (column === 'sno') {
            // Sort by the order in which records appear, using array indices
            sortedItems = [...items].sort((a, b) => {
                const indexA = items.indexOf(a);
                const indexB = items.indexOf(b);
                return sortOrder === 'asc' ? indexA - indexB : indexB - indexA;
            });
        } else {
            // General sorting based on column value
            sortedItems = [...items].sort((a, b) => {
                if (a[column] < b[column]) return sortOrder === 'asc' ? -1 : 1;
                if (a[column] > b[column]) return sortOrder === 'asc' ? 1 : -1;
                return 0;
            });
        }

        setItems(sortedItems);
        setSortColumn(column);
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    };

    const exportToExcel = () => {
        const filteredBranchNames = filteredItems.map(item => ({
            CompleteName: item.comp_name,
            Employeecode: item.emp_code,
            TransCode: item.trans_code,
            grade: item.grade,
            Location: item.location_name,
            fromdate: item.from_date,
            todate: item.to_date,
            purpose: item.purpose,
            rm: item.report_mngr,
            days: item.days,
            AuditApprovedAmount: item.audit_approved_amount,
            rmstatus: item.rpt_mgr_status,
            fin_status: item.account_status,
        }));
        const worksheet = XLSX.utils.json_to_sheet(filteredBranchNames);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Settlement');
        XLSX.writeFile(workbook, 'Settlement_Details.xlsx');
    };

    const overlayStyle = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999
    };

    const modalStyle = {
        background: "#fff",
        padding: "20px",
        borderRadius: "8px",
        width: "600px",
        maxHeight: "80vh",
        overflowY: "auto"
    };

    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h4 className="m-0" style={{ fontSize: '20px' }}>Tour/Travel Settlement Finance Approval Form</h4>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item" style={{ fontSize: '12px' }}><a href="/dashboard">Home</a></li>

                                        <li className="breadcrumb-item active" style={{ fontSize: '12px' }}>Tour/Travel Settlement Finance Approval Form</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <Loader /> // Show loader if loading is true
                    ) : (
                        <>
                            <section className="content">
                                <div className="container-fluid">
                                    <div className="row">
                                        <section className="col-lg-12 connectedSortable">
                                            <div className="card">
                                                <div className="card-header">
                                                    <div className="row align-items-center">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label>Finance Status Filter</label>
                                                                <select
                                                                    className="form-control custom-select-sm"
                                                                    value={financeStatusFilter}
                                                                    onChange={handleFinanceStatusChange}
                                                                >
                                                                    <option value="">All</option>
                                                                    <option value="Pending">Pending</option>
                                                                    <option value="Approved">Approved</option>
                                                                    <option value="Rejected">Rejected</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-8 text-right">
                                                            <button type="button" className="btn btn-secondary" onClick={exportToExcel}>
                                                                Export to Excel
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <div id="example1_filter" style={{ float: 'right' }} className="dataTables_filter">
                                                        <label>
                                                            <input
                                                                type="search"
                                                                value={searchQuery}
                                                                onChange={handleSearchChange}
                                                                className="form-control form-control-sm"
                                                                placeholder="Search"
                                                                aria-controls="example1"
                                                            />
                                                        </label>
                                                    </div>

                                                    <div className="form-group">
                                                        <select
                                                            className="form-control custom-select-sm"
                                                            value={itemsPerPage}
                                                            onChange={handleItemsPerPageChange}
                                                        >
                                                            <option value={10}>10</option>
                                                            <option value={50}>50</option>
                                                            <option value={100}>100</option>
                                                        </select>
                                                    </div>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-striped" style={{ fontSize: '13px' }}>
                                                            <thead>
                                                                <tr>
                                                                    <th
                                                                        onClick={() => handleSort("sno")}
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            backgroundColor: sortColumn === "sno" ? '#f8f9fa' : 'transparent',
                                                                            position: 'relative'
                                                                        }}
                                                                    >
                                                                        S.No {sortColumn === "sno" && (sortOrder === "asc" ? '▲' : '▼')}
                                                                        {/* Adding arrows for sorting indication */}
                                                                        <span
                                                                            style={{
                                                                                position: 'absolute',
                                                                                right: '10px',
                                                                                color: '#007bff',
                                                                                fontSize: '12px',
                                                                                textDecoration: 'underline',
                                                                            }}
                                                                        >

                                                                        </span>
                                                                    </th>

                                                                    <th>
                                                                        Emp Code
                                                                    </th>
                                                                    <th>
                                                                        Trans Code
                                                                    </th>
                                                                    <th>
                                                                        Emp Name
                                                                    </th>

                                                                    <th>
                                                                        Grade
                                                                    </th>
                                                                    <th>
                                                                        Location
                                                                    </th>
                                                                    <th>From Date</th>
                                                                    <th>To Date</th>
                                                                    <th>
                                                                        Purpose
                                                                    </th>

                                                                    <th>
                                                                        Audit Approved Amount
                                                                    </th>

                                                                    <th>
                                                                        Reporting Manager
                                                                    </th>
                                                                    <th>
                                                                        Days
                                                                    </th>


                                                                    <th>
                                                                        Reporting Manager Status
                                                                    </th>

                                                                    <th>
                                                                        Audit Status
                                                                    </th>

                                                                    <th>
                                                                        Finance Status
                                                                    </th>

                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {is_finance_approval && currentItems.length > 0 ? (
                                                                    currentItems.some(item => item.rpt_mgr_status !== 'Rejected') ? (
                                                                        currentItems.map((item, index) => (

                                                                            <tr key={index}>
                                                                                <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                                                                <td>{item.emp_code}</td>
                                                                                <td>{item.trans_code}</td>
                                                                                <td>{item.comp_name}</td>
                                                                                <td>{item.grade}</td>
                                                                                <td>{item.location_name}</td>
                                                                                <td>{item.from_date}</td>
                                                                                <td>{item.to_date}</td>
                                                                                <td>{item.purpose ? item.purpose : item.settlement_purpose}</td>

                                                                                <td>
                                                                                    {Math.trunc(item.audit_approved_amount)}
                                                                                </td>
                                                                                <td>{item.report_mngr}</td>
                                                                                <td>{item.days}</td>


                                                                                <td style={{
                                                                                    color: item.rpt_mgr_status === 'Pending' ? 'orange' :
                                                                                        item.rpt_mgr_status === 'Rejected' ? 'red' :
                                                                                            item.rpt_mgr_status === 'Approved' ? 'green' :
                                                                                                'inherit'
                                                                                }}>
                                                                                    {item.rpt_mgr_status}
                                                                                </td>

                                                                                <td style={{
                                                                                    color: item.audit_status === 'Pending' ? 'orange' :
                                                                                        item.audit_status === 'Rejected' ? 'red' :
                                                                                            item.audit_status === 'Approved' ? 'green' :
                                                                                                'inherit'
                                                                                }}>
                                                                                    {item.audit_status}
                                                                                </td>

                                                                                <td style={{
                                                                                    color: item.account_status === 'Pending' ? 'orange' :
                                                                                        item.account_status === 'Rejected' ? 'red' :
                                                                                            item.account_status === 'Approved' ? 'green' :
                                                                                                'inherit'
                                                                                }}>
                                                                                    {item.account_status}
                                                                                </td>



                                                                                <td>
                                                                                    {item.ExStation === 'Y' ? (
                                                                                        <Link to={`/edit_finance_exstation_form/${item.id}`}>
                                                                                            <i className="fa fa-edit" style={{ fontSize: '12px', color: 'green', marginRight: '8px' }}></i>
                                                                                        </Link>
                                                                                    ) : item.Group === 'Y' ? (
                                                                                        <Link to={`/edit_finance_settlement_form_group/${item.id}`}>
                                                                                            <i className="fa fa-edit" style={{ fontSize: '12px', color: 'green', marginRight: '8px' }}></i>
                                                                                        </Link>
                                                                                    ) : (
                                                                                        <Link to={`/edit_finance_settlement_form/${item.id}`}>
                                                                                            <i className="fa fa-edit" style={{ fontSize: '12px', color: 'green', marginRight: '8px' }}></i>
                                                                                        </Link>
                                                                                    )}
                                                                                    <i
                                                                                        className="fa fa-eye"
                                                                                        onClick={() => handleLog(item.id)}
                                                                                        style={{ fontSize: '12px', color: 'green', cursor: 'pointer' }}
                                                                                    ></i>
                                                                                </td>
                                                                            </tr>
                                                                            // Skip rendering if the conditions are not met
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="15" style={{ textAlign: 'center' }}>No data available</td>
                                                                        </tr>
                                                                    )
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="15" style={{ textAlign: 'center' }}>No data available</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                handlePageChange={handlePageChange}
                                            />
                                            <div className="mb-3">
                                                Showing {startItem} to {endItem} of {filteredItems.length} entries
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </section>
                        </>
                    )}
                    {showLogPopup && (
                        <div style={overlayStyle}>
                            <div style={{ ...modalStyle, maxWidth: "900px" }}>
                                <h4 style={{ marginBottom: "15px" }}>
                                    Settlement Amount Summary
                                </h4>

                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        gap: "16px"
                                    }}
                                >
                                    {/* ================= USER CLAIMED ================= */}
                                    <div
                                        style={{
                                            border: "1px solid #cbd5e1",
                                            borderRadius: "10px",
                                            padding: "14px",
                                            background: "#f8fafc"
                                        }}
                                    >
                                        <h5 style={{ marginBottom: "10px" }}>💼 User Claimed</h5>

                                        <table style={{ width: "100%", fontSize: "14px" }}>
                                            <tbody>
                                                <tr>
                                                    <td>Employee</td>
                                                    <td align="right">
                                                        {claimedParsed?.settlement?.comp_name}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Per Diem</td>
                                                    <td align="right">
                                                        ₹ {claimedParsed?.settlementModel1?.[0]?.perDiem || 0}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Local Conveyance</td>
                                                    <td align="right">
                                                        ₹ {claimedParsed?.settlementModel2?.[0]?.travelAmount || 0}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Misc</td>
                                                    <td align="right">
                                                        ₹ {claimedParsed?.settlementModel1?.[0]?.misc || 0}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><b>Total Claimed</b></td>
                                                    <td align="right">
                                                        <b>₹ {claimedParsed?.settlement?.TotalAmount || 0}</b>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* ================= AUDIT APPROVED ================= */}
                                    <div
                                        style={{
                                            border: "1px solid #bbf7d0",
                                            borderRadius: "10px",
                                            padding: "14px",
                                            background: "#ecfdf5"
                                        }}
                                    >
                                        <h5 style={{ marginBottom: "10px" }}>✅ Audit Approved</h5>

                                        <table style={{ width: "100%", fontSize: "14px" }}>
                                            <tbody>
                                                <tr>
                                                    <td>Audit Status</td>
                                                    <td align="right">
                                                        <b>{auditParsed?.audit_status}</b>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Per Diem</td>
                                                    <td align="right">
                                                        ₹ {auditParsed?.total_per_diem || 0}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Local Conveyance</td>
                                                    <td align="right">
                                                        ₹ {auditParsed?.total_local_conveyance || 0}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Misc</td>
                                                    <td align="right">
                                                        ₹ {auditParsed?.total_misc || 0}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><b>Final Approved</b></td>
                                                    <td align="right">
                                                        <b style={{ color: "#047857" }}>
                                                            ₹ {auditParsed?.audit_approved_amount || auditParsed?.grand_total || 0}
                                                        </b>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* ===== FOOTER ===== */}
                                <div style={{ textAlign: "right", marginTop: "16px" }}>
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => setShowLogPopup(false)}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <Footer />

                <aside className="control-sidebar control-sidebar-dark">
                </aside>
            </div>
        </div>
    );
};

export default FinanceSettlementForm;
